import { Blueprint } from '../../blueprint.class';
import { ToolResult } from '../../types';

export interface IslandInfo {
	id: string;
	width: number;
	height: number;
	depth: number | { left?: number; right?: number };
	connectionCount: number;
}

export const listIslandsTool = (blueprint: Blueprint): ToolResult<IslandInfo[]> => {
	const kitchen = blueprint.kitchens.getActiveVersion();
	if (!kitchen) return { success: false, error: 'No active kitchen found.' };

	const islands = kitchen.design.islands.children.map((island) => ({
		id: island.id,
		width: island.size.width,
		height: island.size.height,
		depth: island.size.depth as number | { left?: number; right?: number },
		connectionCount: island.connections?.children?.length || 0
	}));

	return {
		success: true,
		message: `Found ${islands.length} island(s).`,
		data: islands
	};
};
